import { render, staticRenderFns } from "./OrderShipment.vue?vue&type=template&id=7369c648&scoped=true&"
import script from "./OrderShipment.vue?vue&type=script&lang=js&"
export * from "./OrderShipment.vue?vue&type=script&lang=js&"
import style0 from "./OrderShipment.vue?vue&type=style&index=0&id=7369c648&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7369c648",
  null
  
)

export default component.exports